import type { AxiosInstance } from 'axios';
import type {
  CreateMessageGenSessionRequest,
  MessageGenSession,
  MessageGenChatRequest,
  MarketingMessage,
  MessageGenState,
} from '../types/message-generation.js';

export class MessageGenerationClient {
  constructor(private authenticatedClient: AxiosInstance) {}

  createSession = async (data: CreateMessageGenSessionRequest): Promise<MessageGenSession> => {
    const res = await this.authenticatedClient.post<MessageGenSession>('/message-gen-sessions', data);
    return res.data;
  };

  getSession = async (sessionId: string): Promise<MessageGenSession> => {
    const res = await this.authenticatedClient.get<MessageGenSession>(`/message-gen-sessions/${sessionId}`);
    return res.data;
  };

  /** Send a user chat message to the LangGraph agent and receive the response. */
  chat = async (data: MessageGenChatRequest): Promise<{ responseMessage: string; state: MessageGenState }> => {
    const res = await this.authenticatedClient.post<{ responseMessage: string; state: MessageGenState }>(
      '/message-gen-sessions/chat',
      data,
    );
    return res.data;
  };

  startSession = async (): Promise<{ sessionId: string; chatInstanceId: string }> => {
    const res = await this.authenticatedClient.post<{ sessionId: string; chatInstanceId: string }>(
      '/message-gen-sessions/start',
    );
    return res.data;
  };

  listMessages = async (sessionId: string): Promise<MarketingMessage[]> => {
    const res = await this.authenticatedClient.get<MarketingMessage[]>(`/message-gen-sessions/${sessionId}/messages`);
    return res.data;
  };

  updateMessage = async (
    sessionId: string,
    messageIndex: number,
    updates: Partial<MarketingMessage>
  ): Promise<MarketingMessage> => {
    const res = await this.authenticatedClient.patch<MarketingMessage>(
      `/message-gen-sessions/${sessionId}/messages/${messageIndex}`,
      updates
    );
    return res.data;
  };
}
